
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-env-tag',
  imports: [],
  templateUrl: './envTag.component.html',
  styleUrl: './envTag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class EnvTagComponent { 

  private _config: ConfigService = inject(ConfigService);

  public get getEnvTag(): {tag: string, color: string} | undefined {
    let remoteUrl = this._config.apiUrl;

    if(remoteUrl.includes('localhost')) 
    {
      return {tag: 'localhost', color: '#A3B231'};
    } 
    else if(remoteUrl.includes('dev')) 
    {
      return {tag: 'dev', color: '#2F80ED'};
    }
    else if(remoteUrl.includes('staging')) 
    {
      return {tag: 'staging', color: '#EBBC2E'};
    }
    else if(remoteUrl.includes('uat')) 
    {
      return {tag: 'staging', color: '#EBBC2E'};
    }
    if(remoteUrl.includes('-services-')) 
    {
      return  {tag: 'preflight', color: '#A3B231'};
    }

    return undefined;
  }

}
